// extracted by mini-css-extract-plugin
export default {"container":"ContactsItem_container__DjPW8","burgerButton":"ContactsItem_burgerButton__AFLMq","droplist":"ContactsItem_droplist__mzsIY"};